<template>
  
  <v-card class="elevation-0">
    <div id="loadingOverlay" :style="loadingOverlayStyle">
        <div class="loader" :style="spinnerStyle"></div>
    </div>

    <v-card-title class="font-weight-normal">{{ $t('games.title') }}</v-card-title>
    <v-card-subtitle class="font-weight-light">{{ $t('games.subtitle') }}</v-card-subtitle>  
    
    <v-tabs v-model="tab" class="d-flex align-center align-end">
      <v-tab
        v-for="item in items"
        :key="item.tab"
        active-class="black--text"
        class="text-capitalize"
        @change="runFilters(item.tab)"
      >
        {{ item.tab }}
      </v-tab>

      <v-spacer></v-spacer>
      <v-btn class="black white--text ml-8 text-capitalize align-self-center" small to="/game/new"><v-icon class="mr-2" small>mdi-plus</v-icon>{{ $t("details.addNew")}}</v-btn>
      <v-btn 
        class="red white--text ml-8 text-capitalize align-self-center" 
        small 
        @click="triggerDeleteConfirmation()"
        :style="disableDeleteBtnStyle"
        >
        Delete
      </v-btn>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
      >
        <v-card>
          <v-card-title class="mt-0 pt-0 pb-0 mb-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Wheels by Name"
              single-line
              hide-details
              class="mt-0 pt-0 pb-0 mb-0 d-flex justify-start"
              style="max-width: 300px;"
            ></v-text-field>
            
            <v-select
              v-model="segmentNumberFilter"   
              :items="segments"
              class="selectWidth pt-5 ml-auto"
              label="Number of Segments"
              outlined
              dense
            >
            </v-select>
            <v-select
              v-model="tiersNumberFilter"   
              :items="tiers"
              class="selectWidth pt-5 ml-2  "
              label="Number of Tiers"
              outlined
              dense
            >
            </v-select>
          </v-card-title>


          <v-data-table
            :headers="headers"
            :items="tableItems"
            :search="search"
            :loading="loading"
            show-select
            v-model="selectedItems"
            item-key="id"
            :items-per-page="10"
          >
            <template v-slot:[`item.status`]="{ item }">
              <div class="d-flex justify-center">
                <v-chip
                  :color="item.status == 'Complete' ? 'green' : 'orange'"
                  dark
                  class="ma-0 d-flex justify-center align-center"
                  :style="{ width: '130px' }"
                >
                  <span class="text-center">{{ item.status }}</span>
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.dateCreated`]="{ item }">
              <div class="d-flex justify-center mr-4">
                {{ item.dateCreated }}
              </div>
            </template>
            <template v-slot:[`item.noOfSegments`]="{ item }">
              <div class="d-flex justify-center mr-6">
                {{ item.noOfSegments }}
              </div>
            </template>
            <template v-slot:[`item.noOfTiers`]="{ item }">
              <div class="d-flex justify-center mr-5">
                {{ item.noOfTiers }}
              </div>
            </template>
            <template v-slot:[`item.gameRule`]="{ item }">
              <div class="d-flex justify-center">
                <div v-show="item.gameRule && item.gameRule != '' " style="display: flex;">
                  {{ item.gameRule }}
                  <v-icon
                   v-show="item.gameRule && item.gameRule != '' "
                    small
                    class="ml-1"
                    @click="triggerDeleteRuleConfirmation(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </div>
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex justify-center">
                <div style="display: flex;">
                  <v-icon
                    small
                    class="mr-2"
                    :style="disableActionsStyle"
                    :class="item.tenantId == 'shared' && getTenant != 'shared' ? 'disabled' : ''"
                    @click="editGame(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    :style="disableActionsStyle"
                    @click="cloneGame(item)"
                  >
                    mdi-content-copy
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    :style="disableActionsStyle"
                    @click="triggerDeleteConfirmation(item)"
                  >
                    mdi-delete
                  </v-icon>
                  <v-icon v-show="item.type == 'complete_game' && item.presignedUrl && item.presignedUrl != '' && item.presignedUrl != 'null'"
                    small
                    @click="downloadGame(item)"
                    :style="disableActionsStyle"
                  >
                    mdi-download
                  </v-icon>
                  <v-icon v-show="item.type == 'complete_game' && (!item.presignedUrl || item.presignedUrl == 'null')" 
                    small
                    @click="buildGame(item)"
                    :style="disableActionsStyle"
                    :class="buildingIds.includes(item.displayName) ? 'spin disabledBtn' : ''"
                  >
                    mdi-reload
                  </v-icon>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline align-self-center text-center">{{ $t("details.confirmDelete")}}</v-card-title>
          <v-card-actions>
            <v-btn color="primary" text @click="deleteWheelGame">Yes</v-btn>
            <v-btn color="red" text @click="deleteDialog = false;">No</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="deleteRuleDialog" max-width="500px">
        <v-card>
          <v-card-title class="align-self-center text-center">{{ $t("details.confirmGameRuleDeleteFirstLine")}}</v-card-title>
          <v-card-subtitle class="align-self-center text-center">{{ $t("details.confirmGameRuleDeleteSecondLine")}}</v-card-subtitle>
          <v-card-actions>
            <v-btn color="primary" text @click="deleteRule">Yes</v-btn>
            <v-btn color="red" text @click="deleteRuleDialog = false;">No</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-card>
  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from '../router'
import { connectContentService } from "@/utils/sockets";

export default {
  name: 'Games',
  data () {
    return {
      tab: null,
      items: [
          { tab: 'All Wheels', content: 'Clear filter to show all wheels' },
          { tab: 'Drafts', content: 'Apply filter to show ones in draft' },
          { tab: 'Completed', content: 'Apply filter to show all wheels' },
        ],
      deleteDialog: false,
      loading: true,
      tableItems: [],
      selectedItems: [],
      headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'name',
            search: 'name'
          },
          { text: 'Date Created', value: 'dateCreated', filterable: false, sort: this.sortDate, align: 'center'
          },
          { text: 'Segments', value: 'noOfSegments', filterable: false, align: 'center' },
          { text: 'Tiers', value: 'noOfTiers', filterable: false, align: 'center' },
          { text: 'Status', value: 'status', filterable: false, align: 'center' },
          { text: 'Game Rule', value: 'gameRule', filterable: false, align: 'center' },
          { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
      ],
      search: '',
      segments: ["All", 3, 9, 18, 27, 54],
      tiers: ["All", 1, 2, 3, 4],
      segmentNumberFilter: 'All',
      tiersNumberFilter: 'All',
      downloading: false,
      deleteGame: null,
      buildingIds: [],
      deleteRuleDialog: false,
      deleteRuleGameId: null
    }
  },
  async created() {
    this.loading = true;
    await this.getAllWheels({tenantId: this.getTenant, update: 'addNewGameAction'});
    this.loading = false;
    this.tableItems = this.getGamesList.slice();
  },
  mounted() {
    if (this.getGamesList != null && this.getGamesList.length > 0) {
      this.loading = false;
    }
    connectContentService({
      handleGameZipBuilt: this.handleGameZipBuilt,
      handleGameZipUrlExpired: this.handleGameZipUrlExpired
    });
  },
  watch: {
    segmentNumberFilter() {
      this.runFilters();
    },
    tiersNumberFilter() {
      this.runFilters();
    },
  },
  methods: {
    ...mapActions(["deleteContent", "getAllWheels", "getGame", "downloadGameZip", "uploadGameZip",
    "deleteContents", "cloneGameAction", "deleteWheelAssets", "updateWheelGamePresignedUrl", "clearWheels",
    "generateGameJSON", "saveGame", "removeGameRule", "uploadWheelGame", "saveGameRule"]),
    async buildGame(game) {
      let response = await this.getGame(game.id);
      if (response == false) {
        this.$toast.error("Error. Please rebuild the game manually by editing the game and following the steps.");
      } else {
        this.buildingIds.push(game.displayName);
        await this.generateGameJSON();
        await this.uploadWheelGame({'incompleteGame' : false});
        await this.uploadGameZip();
        if (this.getSelectedGame.gameRule && this.getSelectedGame.gameRule != "") {
          await this.saveGameRule();
        }
        this.$toast.success("Your game has been added to the queue. Download will be available once it has been built.");
      }
    },
    sortDate(a, b) {
      const aSplitDate = a.split('/');
      const bSplitDate = b.split('/');
      const aNewDate = aSplitDate[1] + '/' + aSplitDate[0] + '/' + aSplitDate[2];
      const bNewDate = bSplitDate[1] + '/' + bSplitDate[0] + '/' + bSplitDate[2];
      let aDate = new Date(aNewDate).getTime();
      let bDate = new Date(bNewDate).getTime();

      if (aDate > bDate) {
        return 1;
      } else if (aDate < bDate) {
        return -1;
      } else {
        return 0;
      }
    },
    runFilters(newTab) {
      const tab = newTab ? newTab : this.items[this.tab].tab;
      //Tabs
      this.tableItems = [];
      if (tab == "Completed") {
        this.getGamesList.forEach(game => {
          if (game.status == "Complete") this.tableItems.push(game);
        });
      } else if (tab == "Drafts") {
        this.getGamesList.forEach(game => {
          if (game.status == "Draft") this.tableItems.push(game);
        });
      } else {
        this.tableItems = this.getGamesList.slice();
      } 
      
      //Filter by segment number
      if (this.segmentNumberFilter != 'All') {
        let thiz = this;
        this.tableItems = this.tableItems.filter(function (game) {
          return game.noOfSegments == thiz.segmentNumberFilter;
        });
      }

      //Filter by tier number
      if (this.tiersNumberFilter != 'All') {
        let thiz = this;
        this.tableItems = this.tableItems.filter(function (game) {
          return game.noOfTiers == thiz.tiersNumberFilter;
        });
      }
    },
    showGame(game, item) {
      if (item.tab == "Completed" && game.type == 'draft_game') {
        return false;
      }
      if (item.tab == "Drafts" && !game.name == 'complete_game') {
        return false;
      }
      return true;
    },
    async editGame(id) {
      this.downloading = true;
      await this.getGame(id);
      this.downloading = false;
      router.push("/game/new");
    },
    async cloneGame(item) {
      this.downloading = true;
      // if (item.tenantId == "shared" && this.getTenant != 'shared') {
        
      // }
      await this.getGame(item.id);
      await this.cloneGameAction();
      this.downloading = false;
      router.push("/game/new");
    },
    async deleteWheelGame() {
      this.downloading = true;
      if (this.selectedItems.length > 0) {
        let ids = [];
        let groupIds = [];
        for (let i = 0; i < this.selectedItems.length; i++) {
          if (this.selectedItems[i].tenantId == "shared" && this.getTenant != 'shared') {
            this.$toast.error("Cannot delete standard wheels.");
            this.deleteDialog = false;
            this.downloading = false; 
            return;
          }
          if (this.selectedItems[i].status == 'Complete') {
            ids.push(this.selectedItems[i].groupId);
          }
          ids.push(this.selectedItems[i].id);
          groupIds.push(this.selectedItems[i].groupId);
        }
        await this.deleteContents({ids: ids, type: "bulkGames", user: this.getUser});
        await this.deleteWheelAssets(groupIds);
        this.downloading = false;
        location.reload();
        
      } else {
        if (this.deleteGame.tenantId == "shared" && this.getTenant != 'shared') {
          this.$toast.error("Cannot delete standard wheel.");
          this.deleteDialog = false;
          this.downloading = false;
          return;
        }
        await this.deleteContent({
          id: this.deleteGame.id, 
          explicitUserDeletion: true, 
          user: this.getUser
        });
        if (this.deleteGame.status == 'Complete') {
          await this.deleteContent({
            id: this.deleteGame.groupId, 
            explicitUserDeletion: true, 
            user: this.getUser
          });
        }
        await this.deleteWheelAssets([this.deleteGame.groupId]);
        this.downloading = false;
        location.reload();
      }
      
      this.deleteDialog = false;
    },
    triggerDeleteConfirmation(game) {
      this.deleteGame = game;
      this.deleteDialog = true;
    },
    async downloadGame(game) {
      if (game.presignedUrl && game.presignedUrl != '' && game.presignedUrl != 'null') {
        window.location.href = game.presignedUrl;
      }
    },
    async handleGameZipBuilt(message) {
      await this.updateWheelGamePresignedUrl(message);
      this.clearWheels();
      await this.getAllWheels({tenantId: this.getTenant, update: 'addNewGameAction'});
      this.tableItems = this.getGamesList.slice();
    
      const index = this.buildingIds.indexOf(message.displayName);
      if (index !== -1) {
        this.buildingIds.splice(index, 1);
      }
    },
    async handleGameZipUrlExpired() {
      this.clearWheels();
      await this.getAllWheels({tenantId: this.getTenant, update: 'addNewGameAction'});
      this.tableItems = this.getGamesList.slice();
    },
    triggerDeleteRuleConfirmation(id) {
      this.deleteRuleGameId = id;
      this.deleteRuleDialog = true;
    },
    async deleteRule() {
      this.deleteRuleDialog = false;
      this.downloading = true;
      await this.getGame(this.deleteRuleGameId);
      await this.removeGameRule();
      if (this.getSelectedGame.type == "complete_game") {
        await this.saveGame("complete"); 
      } else {
        await this.saveGame("draft");
      }
      this.clearWheels();
      await this.getAllWheels({tenantId: this.getTenant, update: 'addNewGameAction'});
      this.tableItems = this.getGamesList.slice();
      this.deleteRuleGameId = null;
      this.downloading = false;
    }
  },
  computed: {
    ...mapGetters(["getGamesList", "getTenant", "getGamesList", "getSelectedGame"]),
    getUser() {
      try {
        const stored = localStorage.getItem("user");
        if (!stored) return null;
        const parsed = JSON.parse(stored);
        return parsed && parsed.name ? parsed.name : null;
      } catch (e) {
        return null;
      }
    },
    spinnerStyle() {
        return this.downloading ? 'pointer-events: none' : '';
    },
    loadingOverlayStyle() {
        return this.downloading ? '' : 'display: none';
    },
    disableActionsStyle() {
      return this.selectedItems.length > 0 ? 'pointer-events: none; opacity: 0.6' : ''; 
    },
    disableDeleteBtnStyle() {
      return this.selectedItems.length < 1 ? 'pointer-events: none; opacity: 0.6' : ''; 
    },
  }
}
</script>

<style scoped>
.gameItem {
  border: 1px solid black;
  border-radius: 1em;
}
.selectWidth {
  max-width: 310px;
}

#loadingOverlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.disabled {
  pointer-events: none;
  opacity: 0.6
}
.disabledBtn {
    pointer-events:none;
    opacity: 0.4;
}

.spin {
  animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>